module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TW-05159c46d53b1a984aafb504874c42a4.png";